
import { Options, Vue } from "vue-class-component";
import AlertBox from "@/components/alerts/AlertBox.vue";
import StorageService from "./services/StorageService";

@Options({
  components: {
    AlertBox
  }
})
export default class App extends Vue {
  private storageService = new StorageService();

  created() {
    const user = this.storageService.getUser();
    if (user && user.language) this.$i18n.locale = user.language;
  }
}
